import { cn } from "@/lib/utils";

interface ClaroHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export function ClaroHeader({ children, className }: ClaroHeaderProps) {
  return (
    <div className={cn(
      "bg-primary text-white rounded-lg px-4 py-3 font-semibold uppercase tracking-wide text-sm shadow-md",
      className
    )}>
      {children}
    </div>
  );
}
